const EMPTY_STATE_VARIANTS = {
    DEFAULT: 1,
    NO_CLASSES: 2,
    NO_STUDENTS: 3
};

export default EMPTY_STATE_VARIANTS;



// WEBPACK FOOTER //
// ./components/empty-state/empty-state-constants.js